'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./hqo-theme-79db6cc8.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./enums-de2d9d36.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./index-c3c373ce.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
require('./styles-e0000262.js');
require('./styles-4cf0a0ea.js');
require('./calendar-header-9cff0d7c.js');
require('./component-ac1f77a8.js');
require('./styles-f5c78667.js');
require('./back-link-0ede7a09.js');
require('./styles-b45e911a.js');
require('./styles-d2f31ec6.js');
require('./constants-1c2e2b2b.js');
require('./button-group-de5cad34.js');
require('./button-with-options-c354df43.js');
require('./popover-09eb9e01.js');
require('./calendar-view.styles-be23bcc4.js');
require('./day-labels.styles-152dcd41.js');
require('./day-view.styles-70924b35.js');
require('./days-view.styles-ea58f0e4.js');
require('./buttons-view.styles-d5df4293.js');
require('./styles-1ad7f6ad.js');
var checkboxHqo = require('./checkbox-hqo-d946369c.js');
require('./empty-state-4520e4db.js');
require('./menu-item-dfcda6d2.js');
require('./chip-dropdown-dcd971c2.js');
require('./styles-00533d56.js');
require('./contentBlock-ece87f53.js');
require('./component-294e2694.js');
require('moment');
require('./date-input-title-93b678c0.js');
require('./date-input-container-aa5e7951.js');
require('./component-5bca3e99.js');
require('./drawer-section-2084bccb.js');
require('./dropdown-3f4ce7bb.js');
require('react-dom');
require('./empty-state-v2-d7131509.js');
require('./notification.styles-9c4c6136.js');
require('./file-block-d6c87493.js');
require('./form-group-10ed42fe.js');
require('./component-e4455c39.js');
require('./calendar-wrapper.styles-5423cc8e.js');
require('./calendar-field.styles-5f11b2de.js');
require('./styles-64b3a95d.js');
var hqoMultiselectChips = require('./hqo-multiselect-chips-4c8820d7.js');
require('./hqo-visible-select-2ba14aa8.js');
require('./styles-9361fa87.js');
require('./image-upload-08bc5199.js');
require('./image-upload-fa0fd2dd.js');
require('./index.esm-055407fd.js');
require('./international-phone-input-form-09c1abb0.js');
require('./styles-7e762207.js');
require('./styles-20b982bf.js');
require('./styles-9077e262.js');
require('./modal-a8c021a3.js');
require('./modal-61e0272d.js');
require('./component-a169b61c.js');
require('./component-0d3539a5.js');
require('./styles-56d6022d.js');
require('./close-button-d86113f6.js');
require('./component-cb2dd1a0.js');
require('./styles-8d4a3ad6.js');
require('./errorModal-d7ff3a41.js');
require('./component-f67d65a6.js');
require('./styled-245d62c9.js');
require('./dropdown.component-ed2bfb9e.js');
require('./menu.component-cc597d8a.js');
require('./title.component-1027cd5c.js');
require('./styles-0ce12bea.js');
require('./cell-96115b74.js');
require('./new-table-2511f14f.js');
require('./sortable-header-4cd0bb4d.js');
require('./styles-8735da64.js');
require('./component-1a70d4e9.js');
require('./pin-input-15ae64b6.js');
require('./progress-bar-cfb02ff8.js');
require('./styles-75870089.js');
require('./radio-button-6df8baa3.js');
require('./radio-button-group-cdc27831.js');
require('./styles-4a4d0f0b.js');
var rating = require('./rating-cf21e095.js');
require('./styles-d009fda4.js');
require('./component-3b498127.js');
require('./kebabCase-b150ced7.js');
require('./styles-fb2a64c7.js');
require('./component.styles-89fe8ebe.js');
require('./styles-b3bf24d6.js');
require('./styles-66ea8e11.js');
require('./small-footer-945a9c24.js');
require('./component-a4dabdc0.js');
require('./component-131d3a6b.js');
require('./switch-b3594efa.js');
require('./tab-7d963d53.js');
require('./styles-4efe67ee.js');
require('./themeProvider-842e31f2.js');
require('./time-picker-7099b0c7.js');
require('./time-wrapper.styles-304fa538.js');
require('./time-picker-input.styles-2c771083.js');
require('moment-timezone');
require('./component.styles-9bb0eef7.js');
require('./component.styles-d0eee7a8.js');
require('./styles-8071793d.js');
require('./component-a0032a3a.js');
require('./component.styles-cd2da23e.js');
require('./menu-ec58171a.js');
require('./styles-23854021.js');
require('./styles-2048c729.js');
require('./styles-6845ded1.js');
require('./styles-6941c479.js');
require('./search-input-v2-constants-f31caee4.js');
require('./styles-5b72d46e.js');
require('./pagination-7ad19776.js');

var Title = styled__default.span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: block;\n  font-size: 12px;\n  color: ", ";\n  font-style: italic;\n  padding-bottom: 8px;\n"], ["\n  display: block;\n  font-size: 12px;\n  color: ", ";\n  font-style: italic;\n  padding-bottom: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey6;
});
var MultiselectQuestion = function (_a) {
    var title = _a.title, dataTestId = _a.dataTestId, callback = _a.callback, rest = tslib_es6.__rest(_a, ["title", "dataTestId", "callback"]);
    return (React__default.createElement("div", { "data-testid": dataTestId },
        React__default.createElement(Title, null, title),
        React__default.createElement(hqoMultiselectChips.HqoMultiselectChips, tslib_es6.__assign({}, rest, { onChange: callback, variant: "ghost" }))));
};
var templateObject_1;

var Container = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var Image = styled__default.img(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: block;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n"], ["\n  display: block;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n"])));
var Text = styled__default.p(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin: 0;\n  margin-bottom: 32px;\n  font-size: 28px;\n  line-height: 33px;\n  font-weight: 500;\n  text-align: center;\n  font-family: ", ";\n"], ["\n  margin: 0;\n  margin-bottom: 32px;\n  font-size: 28px;\n  line-height: 33px;\n  font-weight: 500;\n  text-align: center;\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var StyledRating = styled__default(rating.Rating)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  svg {\n    max-width: 60px;\n    max-height: 60px;\n    min-width: 40px;\n    min-height: 40px;\n    width: 14vw;\n    height: 14vw;\n  }\n"], ["\n  svg {\n    max-width: 60px;\n    max-height: 60px;\n    min-width: 40px;\n    min-height: 40px;\n    width: 14vw;\n    height: 14vw;\n  }\n"])));
var RatingQuestion = function (_a) {
    var _b = _a.rating, rating = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 5 : _c, imageUrl = _a.imageUrl, question = _a.question, callback = _a.callback, dataTestId = _a.dataTestId, rest = tslib_es6.__rest(_a, ["rating", "max", "imageUrl", "question", "callback", "dataTestId"]);
    return (React__default.createElement(Container, tslib_es6.__assign({ "data-testid": dataTestId }, rest),
        React__default.createElement(Image, { src: imageUrl, alt: question, "data-testid": "rating-question-image" }),
        React__default.createElement(Text, null, question),
        React__default.createElement(StyledRating, { value: rating, max: max, onChange: callback, size: "xlg" })));
};
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4;

var Container$1 = styled__default.div(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var Chip = styled__default.button(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n  font-weight: 400;\n  padding: 12px;\n  margin: 0 0 32px 0;\n  font-size: 14px;\n  line-height: 16px;\n  border: 1px solid ", ";\n  color: ", ";\n  border-radius: 5px;\n  cursor: pointer;\n  background: ", ";\n  transition: all .3s;\n  font-family: ", ";\n"], ["\n  font-weight: 400;\n  padding: 12px;\n  margin: 0 0 32px 0;\n  font-size: 14px;\n  line-height: 16px;\n  border: 1px solid ", ";\n  color: ", ";\n  border-radius: 5px;\n  cursor: pointer;\n  background: ", ";\n  transition: all .3s;\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.primary : theme.colors.greys.adminGreyDark);
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.primary : theme.colors.greys.darkGrey6);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var Bold = styled__default.span(templateObject_3$1 || (templateObject_3$1 = tslib_es6.__makeTemplateObject(["\n  font-weight: ", ";\n"], ["\n  font-weight: ", ";\n"])), function (_a) {
    var isBold = _a.isBold;
    return (isBold ? 500 : 400);
});
var YesNoQuestion = function (_a) {
    var dataTestId = _a.dataTestId, value = _a.value, optionalNoText = _a.optionalNoText, optionalYesText = _a.optionalYesText, callback = _a.callback;
    var handleClick = React.useCallback(function (result) { return function () {
        callback(result);
    }; }, [callback]);
    var isYesActive = value === 'yes';
    var isNoActive = value === 'no';
    var yesText = optionalYesText ? " - " + optionalYesText : '';
    var noText = optionalNoText ? " - " + optionalNoText : '';
    return (React__default.createElement(Container$1, { "data-testid": dataTestId },
        React__default.createElement(Chip, { "data-testid": "yes-chip", isActive: isYesActive, onClick: handleClick('yes') },
            React__default.createElement(Bold, { isBold: optionalYesText !== '' }, "Yes"),
            yesText),
        React__default.createElement(Chip, { "data-testid": "no-chip", isActive: isNoActive, onClick: handleClick('no') },
            React__default.createElement(Bold, { isBold: optionalNoText !== '' }, "No"),
            noText)));
};
var templateObject_1$2, templateObject_2$1, templateObject_3$1;

var Choice = styled__default.div(templateObject_1$3 || (templateObject_1$3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(54, 54, 54, 0.2);\n  border-radius: 12px;\n  padding: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  border: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(54, 54, 54, 0.2);\n  border-radius: 12px;\n  padding: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  border: ",
    ";\n"])), function (_a) {
    var isMultiple = _a.isMultiple;
    return (isMultiple ? '14px' : '15px');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return "2px solid " + (isActive ? theme.colors.primary
        : theme.colors.universal.transparent);
});
var Checkbox = styled__default(checkboxHqo.CheckboxHqo)(templateObject_2$2 || (templateObject_2$2 = tslib_es6.__makeTemplateObject(["\n  margin-right: 8px;\n  pointer-events: none;\n"], ["\n  margin-right: 8px;\n  pointer-events: none;\n"])));
var SelectQuestion = function (_a) {
    var dataTestId = _a.dataTestId, options = _a.options, value = _a.value, callback = _a.callback, isMultiple = _a.isMultiple, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    var values = React.useMemo(function () { return (typeof value === 'string' ? [value] : value); }, [value]);
    var handleClick = React.useCallback(function (optionValue) { return function () {
        if (!callback || readOnly) {
            return;
        }
        if (isMultiple) {
            var result = (values === null || values === void 0 ? void 0 : values.slice()) || [];
            var removeIdx = result.findIndex(function (option) { return option === optionValue; });
            if (removeIdx > -1) {
                result.splice(removeIdx, 1);
            }
            else {
                result.push(optionValue);
            }
            callback(result);
            return;
        }
        callback(optionValue);
    }; }, [callback, isMultiple, readOnly, values]);
    return (React__default.createElement("div", { "data-testid": dataTestId, className: "hqo-question-select" }, options === null || options === void 0 ? void 0 : options.map(function (option) {
        var isActive = isMultiple ? Boolean(values === null || values === void 0 ? void 0 : values.some(function (v) { return v === option.value; }))
            : value === option.value;
        return (React__default.createElement(Choice, { key: option.value, onClick: handleClick(option.value), isActive: isActive, isMultiple: isMultiple },
            isMultiple && React__default.createElement(Checkbox, { checked: isActive, name: option.value }),
            React__default.createElement("span", null, option.label)));
    })));
};
var templateObject_1$3, templateObject_2$2;

exports.Checkbox = Checkbox;
exports.Choice = Choice;
exports.MultiselectQuestion = MultiselectQuestion;
exports.RatingQuestion = RatingQuestion;
exports.SelectQuestion = SelectQuestion;
exports.YesNoQuestion = YesNoQuestion;
